import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import { LabelType } from '../LabelProvider';
import ProductListingFilter, { ProductListingFilterStyle } from '../ProductListingFilter';

function ProductCategoryFilter(_ref) {
  var _ref$as = _ref.as,
      ElementType = _ref$as === void 0 ? ProductListingFilter : _ref$as,
      filterField = _ref.filterField,
      rest = _objectWithoutProperties(_ref, ["as", "filterField"]);

  return /*#__PURE__*/React.createElement(ElementType, _extends({
    "data-autotag": "grid-category-dd",
    filterField: filterField,
    filterStyle: ProductListingFilterStyle.DEFAULT,
    labelType: LabelType.CATEGORY_FILTER
  }, rest));
}

ProductCategoryFilter.propTypes = {
  as: PropTypes.elementType,
  filterField: PropTypes.shape({
    field: PropTypes.string,
    label: PropTypes.string,
    totalAggregationCount: PropTypes.number,
    items: PropTypes.array
  })
};
export default ProductCategoryFilter;